import React from 'react';

import AlarmVolume from 'src/screen/v2/Protected/DashboardScreen/AlarmVolume';
import AmbientTemperature from 'src/screen/v2/Protected/DashboardScreen/AmbientTemperature';
import AreaFilter from 'src/component/v2/AreaFilter';

export interface GridHeaderProps {
  toggle: React.ReactNode;
  deviceSummary: React.ReactNode;
  alarmVolumeLoading: boolean;
}

export default function GridHeader ({ toggle, deviceSummary, alarmVolumeLoading }: GridHeaderProps) {
  return (
    <div className='ds-flex ds-flex-col ds-gap-2 ds-px-4 ds-pt-4'>
      <div className='ds-flex ds-items-center ds-justify-between ds-gap-4'>
        <AreaFilter className='ds-min-w-0 ds-flex-1' />
        {toggle}
      </div>

      <div className='ds-flex ds-flex-col ds-gap-4 ds-pair:ds-flex-row'>
        <div className='ds-flex ds-min-w-0 ds-grow ds-flex-col ds-gap-4'>
          <AlarmVolume className='ds-grow' loading={alarmVolumeLoading} />
          {deviceSummary}
        </div>
        <AmbientTemperature className='max-ds-pair:ds-w-full ds-pair:ds-w-[300px] ds-pair:ds-shrink-0' />
      </div>
    </div>
  );
}
